module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header": _vm.caption
    }
  }, [_c('b-link', {
    attrs: {
      "to": {
        name: 'product-create'
      }
    }
  }, [_c('b-button', {
    style: ({
      marginBottom: '18px'
    }),
    attrs: {
      "variant": "outline-primary"
    }
  }, [_vm._v("\n    创建产品\n    ")])], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "responsive": "sm",
      "items": _vm.items,
      "fields": _vm.fields,
      "current-page": _vm.currentPage
    }
  }), _vm._v(" "), _c('nav', [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "prev-text": "<<",
      "next-text": ">>",
      "hide-goto-end-buttons": ""
    },
    on: {
      "change": _vm.changePage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2e62908f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/Product.vue
// module id = M/gv
// module chunks = 4